import layoutStyle from "../layout-style"
import { getMarginString, getPaddingString, toRGBA, getFontFamily } from "../utils";
import formBasicScript, { getFormConf } from "../form-basic-script";
import rowHtml from "../../Row/row-html";
import closeButtonHtml from "../../CloseButton/close-button-html";
import countdownBasicScript from "../../Countdown/countdown-basic-script";

export default (tree, preview = false) => {

  const {
    defultFont,
    contentAreaVerticleAlignment = "start",
    backgroundColor,
    sideImageSize,
    sideImageUrl,
    hideOnMobile,
    contentAreaBackgroundColor,
    sideContentAlignment,
    contentAreaAlignment = "center",
    sideContentVerticleAlignment,
    shadowBlur,
    shadowColor,
  } = tree.root.data;
  const rootPaddingStr = getPaddingString(tree.root.data);
  const rootMarginStr = getMarginString(tree.root.data);
  const closeButton = tree.root.extraComponents.closeButton;
  const fontFamily = getFontFamily(defultFont);

  let contentWidth =
    tree.root.data.contentAreaWidthMode === "percentage"
      ? `${tree.root.data.contentAreaWidthPercentage || 100}%`
      : `${tree.root.data.contentAreaWidth}px`;

  const formConf = getFormConf(tree);

  const containerTag = formConf.hasFormComponents ? "form" : "div";

  return `
    <!DOCTYPE html>
    <html>
      <head>
        ${layoutStyle}
        ${
          formConf.libsConfig.ripPhoneLib
            ? `<script src="https://riplus-hk.rimanggis.com/file/rip-mm-vendors/libphonenumber-js-1.11.16.min.js"></script>`
            : ""
        }
        ${
          formConf.libsConfig.ripTermsLib
            ? `<script src="https://riplus-hk.rimanggis.com/file/rip-mm-vendors/jquery.popupoverlay.2.1.5.min.js"></script>`
            : ""
        }
        ${formConf.libsConfig.countdownLib ? countdownBasicScript : ""}
        ${formBasicScript(formConf)}
      </head>
      <body>
        <${containerTag}
          id="rip-mm-container"
          class="rip-mm-container"
          style="
            font-family:${fontFamily};
            font-size: 14px;
            width: 100%;
            min-height:100%;
            background-color: ${toRGBA(backgroundColor)};
            display:flex;
            justify-content: ${contentAreaAlignment};
            align-items: ${contentAreaVerticleAlignment};
            max-width: ${contentWidth};
            position: relative;
          "
        >
          ${closeButtonHtml({ data: closeButton.data })}
          <div style="${rootPaddingStr}${rootMarginStr}display: flex;box-shadow: 0 0 ${shadowBlur}px ${toRGBA(shadowColor)};max-width: ${contentWidth};">

            <div
              class="rip-mm-side-cnt-wrapper ${sideImageSize || 'medium'}"
              style="
                ${rootPaddingStr}
                background-color: ${toRGBA(contentAreaBackgroundColor)};
                align-items: ${sideContentAlignment};
                justify-content: ${sideContentVerticleAlignment};
                ${hideOnMobile === 'on' && 'width:100%;'}
              "
            >
              ${tree.root.children.map((node) => rowHtml(node, tree, "100%", preview)).join("")}
            </div>
            <div class="rip-mm-side-img-wrapper ${sideImageSize || 'medium'} ${hideOnMobile === 'on' && 'rip-mm-hide-on-mobile'}">
            <img
              src="${sideImageUrl}"
              style="width: 100%;height: 100%;object-fit: cover;object-position: center center;"
            />
          </div>
       
          </div>
        </${containerTag}>
      </body>
    </html>
  `
}
